

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Dashboard React components
import DSBox from "components/DSBox";
import DSTypography from "components/DSTypography";

// Custom styles for the WorkWithTheRockets
import styles from "layouts/dashboard/components/WorkWithTheRockets/styles";

function WorkWithTheRockets() {
  const classes = styles();

  return (
    <Card className="h-100">
      
    </Card>
  );
}

export default WorkWithTheRockets;
